'use client';
import { convertDistance } from '@streetferret/geospatial/conversions';
import { cn, formatDistance } from '@streetferret/utils';
import { useMemo } from 'react';
import { usePreferences } from '@streetferret/providers';

// Strava activities store distances in meters, while StreetFerret stores all computed distances in miles
export interface DistanceProps {
  distance: number;
  completed?: number;
  fromUnit: 'meters' | 'miles';
  className?: string;
}
export function Distance({
  distance,
  completed,
  className,
  fromUnit: fromUnitProp = 'meters',
}: DistanceProps) {
  const { unit } = usePreferences();
  const toUnit = unit === 'imperial' ? 'miles' : 'kilometers';
  const distanceConverted = convertDistance(distance, fromUnitProp, toUnit);
  const distanceFormatted = formatDistance(distanceConverted);
  const unitFormatted =
    unit === 'imperial' ? 'mi' : unit === 'metric' ? 'km' : 'mi';

  const completedFormatted = useMemo(() => {
    if (completed === undefined) return undefined;
    const completedConverted = convertDistance(completed, fromUnitProp, toUnit);
    return formatDistance(completedConverted);
  }, [completed, fromUnitProp, toUnit]);

  if (completedFormatted === undefined) {
    return (
      <div className={cn(className)}>
        {distanceFormatted}
        <span className="ml-1">{unitFormatted}</span>
      </div>
    );
  }
  return (
    <div className={cn('inline-flex gap-1', className)}>
      <span>{completedFormatted}</span>
      <span>/</span>
      <span>{distanceFormatted}</span>
      <span>{unitFormatted}</span>
    </div>
  );
}
